var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "basic-container",
    [
      _vm.configDataAll.text
        ? _c("el-alert", {
            attrs: {
              closable: false,
              title: _vm.configDataAll.text.memo,
              type: "warning",
            },
          })
        : _vm._e(),
      _c(
        "div",
        { staticStyle: { "margin-top": "20px", display: "flex" } },
        [
          _c(
            "el-button",
            {
              staticStyle: { width: "100px" },
              attrs: { type: "primary" },
              on: { click: _vm.onRefreshGong },
            },
            [_vm._v("选择险种")]
          ),
          _c(
            "el-select",
            {
              staticStyle: { "margin-left": "30px" },
              attrs: { placeholder: "请选择险种" },
              model: {
                value: _vm.currentInsureTypes,
                callback: function ($$v) {
                  _vm.currentInsureTypes = $$v
                },
                expression: "currentInsureTypes",
              },
            },
            _vm._l(_vm.productOptions, function (item, index) {
              return _c("el-option", {
                key: index,
                attrs: { label: item.label, value: item.value },
              })
            }),
            1
          ),
        ],
        1
      ),
      _vm.currentInsureTypes
        ? _c(
            "div",
            { staticClass: "u-m-t-20" },
            [
              _c(
                "el-card",
                [
                  _c("avue-form", {
                    attrs: { option: _vm.dataOption },
                    model: {
                      value: _vm.currentOptionData,
                      callback: function ($$v) {
                        _vm.currentOptionData = $$v
                      },
                      expression: "currentOptionData",
                    },
                  }),
                  _vm.isShowChild
                    ? _c("avue-form", {
                        attrs: { option: _vm.dataOptionChild },
                        model: {
                          value: _vm.currentOptionChildData,
                          callback: function ($$v) {
                            _vm.currentOptionChildData = $$v
                          },
                          expression: "currentOptionChildData",
                        },
                      })
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "u-flex u-row-center" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { loading: _vm.isLoading, type: "primary" },
                          on: { click: _vm.onSubmitData },
                        },
                        [_vm._v("提交")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { loading: _vm.isLoading, type: "warning" },
                          on: { click: _vm.onRefreshData },
                        },
                        [_vm._v("手动强制刷新")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }